module.exports = __webpack_public_path__ + "static/media/warning.e3753db7.svg";